import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import { Person } from '@mui/icons-material';
import { getDocs } from "firebase/firestore";
import { useFirebaseService } from "../../../data/FirebaseService";

interface AudienceSelectorProps {

    initialSelection: string[];

    onSelectionChange: (selection: string[]) => void;

}

const AudienceSelector: React.FC<AudienceSelectorProps> = ({ initialSelection, onSelectionChange }) => {
    const [allOptions, setAllOptions] = useState<string[]>([]);
    const [availableOptions, setAvailableOptions] = useState<string[]>([]);
    const [selectedOptions, setSelectedOptions] = useState<string[]>(initialSelection);

    const firebaseService = useFirebaseService();

    const handleChange = (event: React.ChangeEvent<object>, newValue: string[]) => {
        setAvailableOptions(allOptions.filter((option) => !newValue.includes(option)));
        setSelectedOptions(newValue);
        onSelectionChange(newValue)
    };

    useEffect(() => {
        setSelectedOptions(initialSelection);
        setAvailableOptions(allOptions.filter((option) => !initialSelection.includes(option)));
    }, [allOptions, initialSelection]);

    useEffect(() => {
        if (firebaseService) {
            const fetchAudienceOptions = async () => {
                const groupCollection = await firebaseService.getCollection(`groups`);
                const groupsSnapshot = await getDocs(groupCollection);
                const groupsList = groupsSnapshot.docs.map(doc => (doc.data().name));

                setAllOptions(["All Staff", ...groupsList]);
            };

            fetchAudienceOptions();
        }
    }, [firebaseService]);

    return (
        <Autocomplete
            multiple
            options={availableOptions}
            value={selectedOptions}
            onChange={handleChange}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        icon={<Person />}
                        label={option}
                        {...getTagProps({ index })}
                        key={option}
                    />
                ))
            }
            renderInput={(params) => <TextField {...params} label="Audience" />}
        />
    );
};

export default AudienceSelector;
